import React, { useEffect, useState } from 'react';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { ButtonComponent } from '../../components/ButtonComponent';
import { TableComponent } from '../../components/TableComponent';
import { IFees } from '../../store/merchnts/merchant-interfaces';
import { fetchFees, setDefaultFees, setFeesConfig } from '../../store/merchnts/actions/fees';
import { FeeConfigurationTableRow } from '../../components/fee-configuration/FeeConfigurationTableRow';

export const feeTableColumn = [
	{
		key: 'name',
		title: 'Fee Name',
		additionalColumnClassName: 'col-2',
	},
	{
		key: 'value',
		title: 'Fee Value',
		additionalColumnClassName: 'col-1',
	},
	{
		key: 'minFeeAmount',
		title: 'Min Fee Amount',
		additionalColumnClassName: 'col-9',
	},
];

export const FeeConfiguration = (): JSX.Element => {
	const { merchantState: { allDefaultFees, standardFees, merchantFee }, dispatch } = useMerchants();

	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		void fetchFees(dispatch, standardFees, merchantFee);
	}, []);

	const onFeeUpdate = (currentFee: IFees, index: number): void => {
		const newData = [...allDefaultFees];
		newData.splice(index, 1 , currentFee);
		setDefaultFees(dispatch, newData);
	};

	const handleSave = async (): Promise<void> => {
		setLoading(true);
		const params = allDefaultFees.map((fee: IFees) => {
			return {
				amount: Math.round(fee.amount * 100),
				minimumFeeAmount: fee.minimumFeeAmount === '' ? null : Math.round(Number(fee.minimumFeeAmount) * 100),
				id: fee.id
			};
		});
		await setFeesConfig(params);
		setLoading(false);
	};

	return (
		<>
			<div className="card mb-10">
				<TableComponent
					column={feeTableColumn}
					tableData={allDefaultFees}
					getRowComponent={(row: IFees, index): JSX.Element => (
						<FeeConfigurationTableRow
							key={row?.id}
							currentFee={row}
							index={index}
							onFeeUpdate={onFeeUpdate}
						/>
					)}
				/>
			</div>

			<ButtonComponent
				buttonName="Save"
				additionalClass="btn-sm ms-auto d-block"
				onButtonClick={(): Promise<void> => !loading && handleSave()}
				isDisabled={loading}
			/>
		</>
	);
};
